import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=f8c4e252&scoped=true&"
import script from "./Heatmap.vue?vue&type=script&lang=js&"
export * from "./Heatmap.vue?vue&type=script&lang=js&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=f8c4e252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c4e252",
  null
  
)

export default component.exports